<template>
  <div ref="show-class">
    <div v-if="!asset.isReady">
      <img src="@/assets/img/spinner.png" alt="" class="spinner-load " >
      <span class="position-center-video">{{ textInformation }}</span>
    </div>
    <!-- <div v-show="asset.type && asset.isReady">
      <img :src="image"  class="img-video-fix"/>
    </div> -->
    <div v-show="asset.type === 'video' && asset.isReady && isHaveVideo">
     <video class="img-video-fix" ref="showVideo"  id="video" :src="asset.src" autoplay autobuffer />
    </div>
    <div v-if="!isHaveVideo && isDone" class="position-center-video w-100">
      <img src="@/assets/img/mandaya.jpeg" class="w-100">

    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isHaveVideo: false,
      textDownload: '',
      asset: {
        id: '',
        src: '',
        isReady: '',
        type: '',
        position: 0
      },
      listVideo: [],
      indexResult: 0
    }
  },
  props: {
    isDone: {
      type: Boolean,
      default: false
    },
    textInformation: {
      type: String,
      default: ''
    },
    assetVideo: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
    if (this.assetVideo.length > 0) {
      this.isHaveVideo = true
      const list = this.assetVideo
      this.listVideo = list
      const divFirst = this.$refs.showVideo
      divFirst.classList.add('show-detail')
      this.asset = this.setToObjectAsset(list, this.asset, true)
      document.getElementById('video').onended = () => {
        divFirst.classList.remove('show-detail')
        const assetBefore = JSON.parse(JSON.stringify(this.asset))
        this.asset = ''
        setTimeout(() => {
          divFirst.classList.add('show-detail')
          this.asset = this.setToObjectAsset(list, assetBefore, false)
        }, 100)
      }
    } else {
      this.isHaveVideo = false
    }
  },
  watch: {
    assetVideo (val) {
      if (!val || val.length === 0) {
        this.isHaveVideo = false
        this.asset = {
          id: '',
          src: '',
          isReady: false,
          type: '',
          position: 0
        }
        return
      }
      this.isHaveVideo = true
      this.listVideo = val
      this.asset = this.setToObjectAsset(val, this.asset, true)

      // Pastikan video element sudah ada sebelum menambahkan event listener
      this.$nextTick(() => {
        const divFirst = this.$refs.showVideo
        const videoElement = document.getElementById('video')
        if (divFirst && videoElement) {
          divFirst.classList.add('show-detail')
          videoElement.onended = () => {
            divFirst.classList.remove('show-detail')
            const assetBefore = JSON.parse(JSON.stringify(this.asset))
            this.asset = ''
            setTimeout(() => {
              divFirst.classList.add('show-detail')
              this.asset = this.setToObjectAsset(val, assetBefore, false)
            }, 100)
          }
        }
      })
    }
  },
  methods: {
    goToVideo (index) {
      this.asset = this.setToObjectAsset(this.listVideo, this.asset, false, index)
    },
    setToObjectAsset (list, asset, play, position = null) {
      const assetIndex = list.findIndex(item => item.src === asset.src)
      if (assetIndex < 0 && play) {
        if (asset.src) {
          // jika file lama sudah dihapus
          const index = asset.position < list.length ? asset.position : 0
          this.searchIndex(list, index)
          return this.addToIndex(list[this.indexResult], this.indexResult)
        } else {
          // belum ada sama sekali asset dijalankan
          this.searchIndex(list, 0)
          return this.addToIndex(list[this.indexResult], this.indexResult)
        }
      } else if (assetIndex >= 0 && play) {
        // ketika asset sudah mempunyai list dan minimal sudah dijalankan
        return this.addToIndex(list[assetIndex], assetIndex)
      } else if (position || position === 0) {
        this.searchIndex(list, position)
        return this.addToIndex(list[this.indexResult], this.indexResult)
      } else {
        // ketika asset masuk ke step berikut nya
        const nextAsset = asset.position + 1 < list.length ? asset.position + 1 : 0
        this.searchIndex(list, nextAsset)
        return this.addToIndex(list[this.indexResult], this.indexResult)
      }
    },
    addToIndex (item, index) {
      return {
        ...item,
        position: index
      }
    },
    searchIndex (item, index) {
      if (item[index].isReady) {
        this.indexResult = index
      } else {
        const nextIndex = item.length > index + 1 ? index + 1 : 0
        this.searchIndex(item, nextIndex)
      }
    }
  }
}
</script>

<style>
    .active{
       background: #636363 !important;
    }

    .position-center-video{
      position: absolute;
      top: 60%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: black;
      font-size: 20px;
      font-weight: 400;
    }
</style>
